import React from "react";
import Accordion from "react-bootstrap/Accordion";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Utils from "../../services/Utils";
import { getImageFullUrl } from '../../services/ApiService';

export default function OperationsList({
  operationType,
  deleteOperationsType,
  handleShowUpdate,
}) {
  return (
    <div>
      <Accordion>
        <Accordion.Item
          eventKey="0"
          className="mb-5 w-100 m-auto"
          style={{
            backgroundColor: Utils.getColorAlternative(operationType.color, 20),
          }}
        >
          <div className="row w100">
            <div className="col-10">
              <Accordion.Header as="div">
                <div className="row w100">
                  <div className="col-10">
                    <span
                      style={{ backgroundColor: operationType.brand.color }}
                      className="rounded white marque"
                    >
                      {operationType.brand.name}
                    </span>
                    <div className="mr-2 text-start ">
                      <span
                        className="accordion-title"
                        style={{ color: operationType.color }}
                      >
                        {operationType.name}{" "}
                      </span>
                      <LocalOfferOutlinedIcon
                        style={{ color: operationType.color }}
                        className="ms-3"
                      />
                    </div>
                  </div>
                </div>
              </Accordion.Header>
            </div>
            <div className="col-2 text-end  pt-2">
              <DropdownButton title={<MoreVertIcon />} className="hidden-arrow">
                <Dropdown.Item
                  onClick={() => {
                    handleShowUpdate(operationType);
                  }}
                >
                  <EditOutlinedIcon className="grey" /> Modifier
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    deleteOperationsType(operationType.id);
                  }}
                >
                  <DeleteOutlinedIcon className="red" /> Supprimer
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </div>

          <div className="container-fluid">
            <Accordion.Body>
              <div className="row pt-0">
                <div className="col-md-4 pb-5 have-border-top pt-3">
                  <div className="pb-4">
                    <div className="data-label">Nom opération</div>
                    <p>{operationType.name}</p>
                  </div>
                  <div>
                    <div className="data-label">Couleur opération</div>
                    <div className="row pt-4">
                      <div className="col-1">
                        <span>
                          <LocalOfferOutlinedIcon
                            style={{ color: operationType.color }}
                          />
                          &emsp;
                        </span>
                      </div>
                      <div className="col-4 m-0">
                        <div>{operationType.color}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 border-start have-border-top pt-4">
                  <div className="data-label px-3">Descriptifs Offre</div>
                  {operationType.operation_descriptions.length > 0 &&
                    operationType.operation_descriptions.map((offer, i) => (
                      <div key={i} className="px-3">
                        {offer.name}
                      </div>
                    ))}
                </div>

                <div className="col-md-4 border-start have-border-top pt-4">
                  <div className="data-label">Média</div>
                  {operationType.media ? <img src={getImageFullUrl(operationType.media)} /> : 'aucun'}
                </div>
              </div>
            </Accordion.Body>
          </div>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
